import React, { useContext, useState } from "react";
import robot from "../../images/panda.png";
import "./home.css";
import { ModeContext } from "../utils/modes-context";
import Navbar from "../navbar/Navbar";

const Home = () => {
  const { darkMode } = useContext(ModeContext);

  return (
    <section className={darkMode ? "home" : "home home_lightmode"} id="home">
      <Navbar />
      <div className="main">
        <div className="text">
          <div className="background_text">
            <span>Krishna</span>
            <span>Khandelwal</span>
          </div>
          <div className="foreground_text">
            <h3>Hello there, I'm</h3>
            <h1>Krishna</h1>
            <h3>A Front-end Developer</h3>
          </div>
        </div>
        <img src={robot} alt="Hello" />
      </div>
    </section>
  );
};

export default Home;
